import { Checkbox, Typography } from 'antd'
import { toIncludedWidgetIdsPayload, type IncludedWidgetOption } from '../scheduleWidgets'
import { VIZ_SWITCHER } from '../vizSwitcher'

type Props = {
  options: IncludedWidgetOption[]
  /** null = every exportable widget, including widgets added later. */
  value?: string[] | null
  onChange?: (value: string[] | null) => void
}

export function IncludedWidgetsField({ options, value = null, onChange }: Props) {
  const exportableIds = options.filter((option) => !option.disabled).map((option) => option.widgetId)
  const selected = value ?? exportableIds
  const selectedCount = exportableIds.filter((id) => selected.includes(id)).length
  const allSelected = exportableIds.length > 0 && selectedCount === exportableIds.length

  // Ticking every exportable widget goes back to null so the schedule picks up future widgets.
  const update = (next: string[]) => onChange?.(toIncludedWidgetIdsPayload(next, options))

  return (
    <div className="rounded-md border border-gray-200" data-testid="included-widgets">
      <div className="border-b border-gray-200 px-3 py-2">
        <Checkbox
          checked={allSelected}
          indeterminate={selectedCount > 0 && !allSelected}
          disabled={exportableIds.length === 0}
          onChange={(event) => onChange?.(event.target.checked ? null : [])}
        >
          {selectedCount} of {exportableIds.length} selected
        </Checkbox>
      </div>
      <div className="max-h-72 overflow-y-auto px-3 py-1">
        {options.map((option) => (
          <div key={option.widgetId} className="flex items-center gap-2 py-1.5">
            <Checkbox
              checked={!option.disabled && selected.includes(option.widgetId)}
              disabled={option.disabled}
              onChange={(event) => update(event.target.checked
                ? [...selected, option.widgetId]
                : selected.filter((id) => id !== option.widgetId))}
            >
              <span className="text-sm">{option.title}</span>
              <Typography.Text type="secondary" className="ml-2 text-xs">
                {option.disabledReason ?? VIZ_SWITCHER.find((entry) => entry.key === option.type)?.label ?? option.type}
              </Typography.Text>
            </Checkbox>
          </div>
        ))}
      </div>
    </div>
  )
}
